export default __webpack_public_path__ + "static/silver-icon-80bb14830ce15824df857cdf7aaa6c02.svg";